(function($, w) {
    'use strict';
    
    if (!w.jQuery) {
        throw 'Tema: jQuery bulunamadı';
    }

    if (!w.Theme) {
        w.Theme = {};
    }

    w.Theme.product = {
        init: function() {
			this.eventListener();
			this.thumbImagesCarousel();
			this.zoom.init();
			this.afterInit();
        },

        afterInit: function() {
            this.responsiveTabs();
        },

        responsiveTabs: function(){
            Theme.product.plugins.productTab('.product-detail-tab', function () {}, function () {});
            $('.product-detail-tab-row [data-tab-index]').on('click', function(event) {
                if($(this).parent().attr('class').indexOf('active') > -1) {
                    $(this).next().slideUp();
                    $(this).parent().removeClass('active');
                } else {
                    $(this).next().slideDown().parent().siblings().find('[data-tab-content]').slideUp();
                    $('.product-detail-tab-row').removeClass('active');
                    $(this).parent().addClass('active');
                }
                $('html, body').animate({
                    scrollTop: $(this).parent().parent().offset().top - 15
                }, 500);
            });
            $('.product-detail-tab-content .product-detail-tab-row.active .active[data-tab-content]').show();
        },

        thumbImagesCarousel: function() {
            $('#product-thumb-image').slick({
                vertical: false,
                arrows: false,
                slidesToShow: 8,
                slidesToScroll: 8,
                responsive: [{
                    breakpoint: 424,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }]
            });
        },

        zoom: {
			config: {
				gallery: 'product-thumb-image',
				responsive: true,
				zoomType: "inner",
				borderSize: 0,
				cursor: 'crosshair',
				onZoomedImageLoaded: function () {
					$('#primary-image').unbind('touchmove mousewheel');
					if($('#product-thumb-image .thumb-item a.zoomGalleryActive').length < 1) {
						$('#product-thumb-image .thumb-item:first-child a').addClass('zoomGalleryActive');
					}
				}
			},
			init: function() {
				$('.zoomContainer').remove();
				$('#primary-image').elevateZoom(this.config);
				this.eventListener();
			},
			eventListener: function() {
				var self = this;
				$('#primary-image').on('click tap', function () {
					$.fancybox.open($(this).data('elevateZoom').getGalleryList(), {
						i18n: {
							en: {
								SHARE: "{{ theme.settings.fancybox_share }}"
							}
						}
					});
					return false;
				});
				$('#product-thumb-image .thumb-item a').on('click tap', function() {
					var image = $('#primary-image');
					$('.zoomContainer').remove();
					image.removeData('elevateZoom').attr('src', $(this).data('image')).data('zoom-image', $(this).data('zoom-image')).elevateZoom(Theme.product.zoom.config);
				});
			}
		},

        plugins: {
            productTab: function(element, onstart, onclick) {
                var tabClass = element;
                Theme.product.plugins.tab(tabClass, function() {
                    if (typeof onstart == 'function') {
                        onstart();
                    }
                }, function() {
                    var $self = $(this)
                      , tabIndex = $self.attr('data-tab-index');
                    if ($self.attr('data-type') == 'payment-option') {
                        if ($self.parents(tabClass).find('[data-tab-content=' + tabIndex + ']').html().trim() != '') {
                            return;
                        }
                        $self.parents(tabClass).find('[data-tab-content=' + tabIndex + ']').html('');
                        Theme.product.loading.add($self.parents(tabClass).find('[data-tab-content=' + tabIndex + ']'));
                        $self.addClass('disabled');
                    }
                }, function() {
                    if (typeof onclick == 'function') {
                        onclick.call(this);
                    }
                });
            },
            tab: function(element, onstart, beforeclick, onclick) {
                $(element).each(function() {
                    if (typeof onstart == 'function') {
                        onstart.call(this)
                    }
                    $(this).find('[data-tab-index]').on('click tap', function() {
                        if (typeof beforeclick == 'function') {
                            beforeclick.call(this)
                        }
                        var self = $(this)
                          , currentIndex = self.attr('data-tab-index')
                          , parents = self.parents(element);
                        parents.find('[data-tab-index]').removeClass('active');
                        parents.find('[data-tab-index="' + currentIndex + '"]').addClass('active');
                        parents.find('[data-tab-content]').removeClass('active');
                        parents.find('[data-tab-content="' + currentIndex + '"]').addClass('active');
                        if (typeof onclick == 'function') {
                            onclick.call(this)
                        }
                    })
                })
            },
            loading: {
                add: function(element) {
                    $(element).append('<div class="loading"><div></div></div>')
                },
                remove: function(element) {
                    $(element).find('.loading').remove()
                }
            }
        },

        eventListener: function() {
            var self = this;
        }
    };

    $(document).ready(function() {
        w.Theme.product.init();
    });
})(jQuery, window);